"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ToggleButton = function ToggleButton(_ref) {
  var level = _ref.level,
      disabled = _ref.disabled,
      children = _ref.children,
      fullwidth = _ref.fullwidth,
      onClick = _ref.onClick,
      icon = _ref.icon,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["level", "disabled", "children", "fullwidth", "onClick", "icon", "className"]);

  var handleClick = function handleClick() {
    if (!disabled) {
      onClick();
    }
  };

  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    level: level,
    onClick: function onClick() {
      return handleClick();
    },
    fullwidth: fullwidth,
    disabled: disabled,
    className: className
  }, otherProps), icon ? /*#__PURE__*/_react.default.createElement(Image, {
    src: icon
  }) : null, children);
};

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "StyledButton"
})(["font-family:", ";background-color:", ";font-weight:500;font-size:1.6rem;border-radius:2.5rem;min-width:12rem;width:", ";height:3.5rem;color:white;border:0;padding:0 1.8rem;display:flex;justify-content:center;align-items:center;cursor:pointer;:focus{outline:none;}:active{transform:scale(0.95);}:hover{background-color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var disabled = _ref3.disabled,
      level = _ref3.level,
      theme = _ref3.theme;
  return disabled ? theme.ui.disabled : level === 'active' ? theme.brand.secondary : theme.ui.interactive;
}, function (_ref4) {
  var fullwidth = _ref4.fullwidth;
  return fullwidth ? '100%' : '';
}, function (_ref5) {
  var theme = _ref5.theme,
      level = _ref5.level;
  return level === 'active' ? '' : theme.hover.primary;
});

var Image = _styledComponents.default.img.withConfig({
  displayName: "Image"
})(["margin-right:0.8rem;height:1.8rem;"]);

ToggleButton.defaultProps = {
  disabled: false,
  level: 'primary',
  fullwidth: false,
  icon: null,
  otherProps: {}
};
ToggleButton.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** If true button is disabled */
  disabled: _propTypes.bool,

  /** The level of the button */
  level: _propTypes.string,

  /** The label of the button */
  children: _propTypes.node.isRequired,

  /** If true button width is 100% */
  fullwidth: _propTypes.bool,

  /** Triggered when button is clicked */
  onClick: _propTypes.func.isRequired,

  /** Adds icon to button */
  icon: _propTypes.node,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = ToggleButton;
exports.default = _default;